import { AuthForm } from './AuthForm';
import type { AuthUser } from '../auth/passkey';
import { BRAND_ICON_SRC, BRAND_LINE_JA, BRAND_LOGO } from '../brand';
import { useStore } from '../state/store';

export function LoginScreen({ onAuthed }: { onAuthed: (user: AuthUser) => void }) {
  const toast = useStore((s) => s.toast);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center overflow-y-auto bg-gradient-to-b from-base-900 via-base-950 to-black px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[calc(max(1.5rem,var(--safe-top))+var(--portrait-top-gap))]">
      <div className="mb-8 text-center">
        <img
          src={BRAND_ICON_SRC}
          alt=""
          width={96}
          height={96}
          className="mx-auto mb-4 h-24 w-24 rounded-2xl shadow-lg shadow-black/40"
          draggable={false}
        />
        <h1 className="brand-mark text-3xl font-bold tracking-tight" aria-label={BRAND_LOGO}>
          EmYu<span className="text-accent">-Ba</span>
        </h1>
        <p className="mt-2 text-sm text-slate-400">{BRAND_LINE_JA}</p>
        <p className="mt-1 text-xs text-slate-500">続行するにはサインインしてください</p>
      </div>

      <div className="w-full max-w-sm rounded-2xl border border-base-700 bg-base-800 p-5 shadow-xl">
        <AuthForm
          onAuthed={onAuthed}
          onInfo={(message, tone) => toast(message, tone ?? 'info')}
        />
      </div>

      <p className="mt-6 max-w-sm text-center text-[0.7rem] leading-relaxed text-slate-600">
        セーブとライブラリ一覧はアカウントに紐づいて同期されます。ROM 本体は各端末に追加してください（サーバーには送りません）。
      </p>
    </div>
  );
}
